import axios from "../api";
export const getStats = async () => {
    const res = await axios.get("/user-clubs/stats");
    return res.data;
};
export default getStats;
//# sourceMappingURL=getStats.js.map